// `/leads` — table route (US-139..US-152, US-153, US-154 surfaces).

import { createRoute } from '@tanstack/react-router';

import { LeadsTablePage } from '@/features/leads/LeadsTablePage';

import { Route as LeadsLayoutRoute } from './__layout';

export const Route = createRoute({
  getParentRoute: () => LeadsLayoutRoute,
  path: '/',
  component: LeadsIndex,
});

function LeadsIndex() {
  return <LeadsTablePage />;
}
